import {Component, inject, OnInit} from '@angular/core';
import {
  IonCol,
  IonContent,
  IonRow,
} from "@ionic/angular/standalone";
import {HeaderComponent} from "../../common/header/header.component";
import {FooterComponent} from "../../common/footer/footer.component";
import {ContactFormComponent} from "./contact-form/contact-form.component";
import {formTypes, messagesColor} from "../../configs/config";
import {ContactDetailsComponent} from "./contact-details/contact-details.component";
import {WeAreHereToHelpComponent} from './we-are-here-to-help/we-are-here-to-help.component';
import {Meta, Title} from '@angular/platform-browser';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'app-contact',
  template: `
    <app-header [filled]="true"></app-header>
    <ion-content>
      <article class="article">
        <app-we-are-here-to-help></app-we-are-here-to-help>
        <ion-row class="ion-justify-content-between">
          <ion-col size-lg="5" size="12">
            <app-contact-details></app-contact-details>
          </ion-col>
          <ion-col size-lg="6.5" size="12">
            <app-contact-form [formType]="formType"></app-contact-form>
          </ion-col>
        </ion-row>
      </article>

      <app-footer></app-footer>
    </ion-content>
  `,
  styles: `$mobile-width: 768px;
  ion-content {
    --padding-top: 96px;
    @media screen and (max-width: $mobile-width) {
      --padding-top: 24px;
    }
  }
  `,
  imports: [
    IonContent,
    HeaderComponent,
    FooterComponent,
    IonRow,
    IonCol,
    ContactFormComponent,
    ContactDetailsComponent,
    WeAreHereToHelpComponent
  ]
})
export class ContactComponent  implements OnInit {
  formType = formTypes.contact;
  constructor(private route: ActivatedRoute) { }

  title: Title = inject(Title);
  meta: Meta = inject(Meta);
  async ngOnInit() {

    this.route.params.subscribe(async params => {
      if (params['form']) {
        this.formType = formTypes.complaints;
      }
    })

    this.title.setTitle('Contact Satel | Real Estate in Riyadh');

    this.meta.addTags([
      {property: 'og:title', content: 'Contact Satel | Real Estate in Riyadh'},
      {name: 'description', content: 'Contact us by phone, email, or through our online form. We\'re available to answer your questions, schedule property viewings, and provide personalized assistance'},
      {property: 'og:description', content: 'Contact us by phone, email, or through our online form. We\'re available to answer your questions, schedule property viewings, and provide personalized assistance'},
      {property: 'og:image', content: 'https://satel.sa/assets/home/img_1.png'},
      {property: 'og:site_name', content: 'satel.sa'},
      {property: 'og:url', content: `https://satel.sa/`},
      {property: 'og:type', content: 'article'},
      {name: 'twitter:site', content: 'satel.sa'},
      {name: 'twitter:title', content: 'Contact Satel | Real Estate in Riyadh'},
      {name: 'twitter:description', content: 'Contact us by phone, email, or through our online form. We\'re available to answer your questions, schedule property viewings, and provide personalized assistance'},
      {name: 'twitter:card', content: 'summary'},
      {name: 'twitter:image', content: 'https://satel.sa/assets/home/img_1.png'}
    ]);
  }

}
